// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import LoginPage from "./pages/Login/LoginPage";
import Dashboard from "./pages/dashboard/Dashboard";
import UsersList from "./components/UsersList/UsersList";
import ChatApp from "./components/ChatApp/ChatApp";
import TransactionsListLayer from "./layers/TransactionsListLayer/TransactionsListLayer";
import RecentActionsFull from "./components/RecentActionsFull/RecentActionsFull";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import PromoList from "./components/PromoList/PromoList";
import Tasks from "./pages/Tasks/Tasks";
import FullDrawer from "./components/FullDrawer/FullDrawer";
import FeePage from "./pages/Fee/Fee";
import InventoryPage from "./pages/Inventory/Inventory";
import GemCatalogPage from "./pages/GemCatalog/GemCatalog";
import PositionSettingsPage from "./pages/PositionSettings/PositionSettingsPage";
import TokenPage from "./pages/Token/TokenPage";
import PaymentPage from "./pages/Payment/PaymentPage";
import AwardsPage from "./pages/Awards/AwardsPage";
import FAQPage from "./pages/FAQ/FAQPage";
import WalletsPage from "./pages/Wallets/WalletsPage";
import BonusPage from "./pages/Bonus/BonusPage";
import DefaultTasksPage from "./pages/DefaultTasks/DefaultTasksPage";
import BlockchainDashboardPage from "./pages/Blockchain/BlockchainDashboardPage";

const ProtectedLayout = ({ children }) => {
    return (
        <div className="relative flex h-screen overflow-hidden bg-[#070A12]">
            {/* Тот же full-viewport фон, что на дашборде: под полупрозрачным sidebar и blur иначе проступает body (antd reset). */}
            <div className="pointer-events-none fixed inset-0 z-0 bg-[#070A12]" aria-hidden />
            <div
                className="pointer-events-none fixed inset-0 z-0 overflow-hidden opacity-[0.55]"
                aria-hidden
            >
                <div className="absolute -left-24 -top-24 h-[380px] w-[380px] rounded-full bg-indigo-500/20 blur-[90px]" />
                <div className="absolute top-40 -right-20 h-[420px] w-[420px] rounded-full bg-fuchsia-500/20 blur-[100px]" />
            </div>

            <Sidebar />
            <div
                className="relative z-10 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-transparent text-white transition-all duration-300"
                style={{ marginLeft: "var(--sidebar-width, 16rem)" }}
            >
                <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">{children}</div>
            </div>
            <FullDrawer />
        </div>
    );
};

const App = () => {
    return (
        <Router>
            <Routes>
                {/* Login */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected area */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <Dashboard />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <UsersList />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/awards"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <AwardsPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/chat"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <ChatApp />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/promos"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <PromoList />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/tasks"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <Tasks />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/transactions"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <TransactionsListLayer />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/payment"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <PaymentPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/fee"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <FeePage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/bonus"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <BonusPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/position-settings"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <PositionSettingsPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/crystals"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <GemCatalogPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/inventory"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <InventoryPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/token"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <TokenPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/actions"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <RecentActionsFull />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/faq"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <FAQPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/wallets"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <WalletsPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/default-tasks"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <DefaultTasksPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/blockchain"
                    element={
                        <ProtectedRoute>
                            <ProtectedLayout>
                                <BlockchainDashboardPage />
                            </ProtectedLayout>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    );
};

export default App;
